import Settings from "../Components/Settings/Settings";

const SettingsView = () => {
  return (
    <div>
      <Settings />
    </div>
  );
};

export default SettingsView;
